// EventVideos.js — the video blocks the hero slides scroll down to.
//
// Desktop stacks the blocks vertically. On a phone they become one
// scroll-snapped row you swipe left and right, which is why the hero's click
// handler uses scrollIntoView with both `block` and `inline`: that scrolls the
// page down AND the row sideways, landing directly on the right video in
// either layout.
import React from 'react';
import { useTranslation } from 'react-i18next';
import VideoReveal from '../common/VideoReveal';
import { videosWithContent } from '../../config/eventVideos';
import './EventVideos.css';

const EventVideos = () => {
  const { t } = useTranslation();
  const events = videosWithContent();

  if (events.length === 0) return null;

  return (
    <section className="event-videos" aria-label={t('eventVideos.sectionLabel', 'Videoer')}>
      <div className="event-videos-track">
        {events.map(event => (
          <article
            key={event.key}
            // The hero slides scroll to these ids.
            id={event.anchorId}
            className="event-video-block"
          >
            <header className="event-video-header">
              <h2>{t(event.titleKey, event.titleDefault)}</h2>
              {/* Either a date or, for an event whose date we don't have, a
                  duration — never the wedding date standing in for both. */}
              <p className="event-video-date">{t(event.metaKey || event.dateKey)}</p>
              {event.descriptionKey ? (
                <p className="event-video-description">
                  {t(event.descriptionKey, event.descriptionDefault)}
                </p>
              ) : null}
            </header>

            {event.youtubeId ? (
              <VideoReveal
                youtubeId={event.youtubeId}
                image={
                  event.useYoutubeThumbnail
                    ? `https://img.youtube.com/vi/${event.youtubeId}/maxresdefault.jpg`
                    : event.posterImage || event.image
                }
                imageFallback={
                  event.useYoutubeThumbnail
                    ? `https://img.youtube.com/vi/${event.youtubeId}/hqdefault.jpg`
                    : undefined
                }
                objectPosition={event.objectPosition}
                title={t(event.titleKey, event.titleDefault)}
                label={t(event.watchKey || 'eventVideos.watch', event.watchDefault || 'Se øyeblikket')}
              />
            ) : (
              /* No video id yet. Show the still so the block has a shape, but
                 without a play button — an affordance that did nothing would
                 read as broken. */
              <div className="event-video-pending">
                <img
                  src={event.posterImage || event.image}
                  alt=""
                  aria-hidden
                  className="event-video-pending-img"
                  loading="lazy"
                  decoding="async"
                />
                <p className="event-video-pending-label">
                  {t('eventVideos.comingSoon', 'Videoen kommer snart')}
                </p>
              </div>
            )}
          </article>
        ))}
      </div>
    </section>
  );
};

export default EventVideos;
